export const paySalaryRouter = [
  {
    path: '/paySalary/SalaryUnitMng',
    name: 'SalaryUnitMng',
    component: () => import('../views/paySalary/SalaryUnitMng')
  },
  {
    path: '/paySalary/TaxReportMng',
    name: 'TaxReportMng',
    component: () => import('../views/paySalary/TaxReportMng')
  },
  {
    path: '/paySalary/TaxReportingDetail',
    name: 'TaxReportingDetail',
    component: () => import('../views/paySalary/TaxReportingDetail')
  },
  {
    path: '/paySalary/InvoiceList',
    name: 'InvoiceList',
    component: () => import('../views/paySalary/InvoiceList')
  },
  {
    path: '/paySalary/ApplyList',
    name: 'ApplyList',
    component: () => import('../views/paySalary/ApplyList')
  },
  // 发放列表
  {
    path: '/paySalary/IssueList',
    name: 'IssueList',
    component: () => import('../views/paySalary/IssueList')
  },
  // 发放列表--详情
  {
    path: '/paySalary/IssueListDetail',
    name: 'IssueListDetail',
    component: () => import('../views/paySalary/IssueListDetail')
  },
  // 发放列表--发放
  {
    path: '/paySalary/PSDistributed',
    name: 'PSDistributed',
    component: () => import('../views/paySalary/PSDistributed')
  },
]